module.exports = "./img/desktop_logo.626ea60.png";